export const REACT_APP_INFURA_PROJECT_ID = "00fe4cd8ea7e4327ae6dd5521d7e5cc9";
export const API_KEY_TOKEN = "ZRHIEKW84X6UVK8SRNH37DSXZEFMXJXIY4";
